import { useContext, useMemo } from "react";
import { LanguageContext } from "./LanguageContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import BlobSVG from "./BlobSVG";
import { Typewriter } from "react-simple-typewriter";
import it from "../translations/it.json";
import en from "../translations/en.json";
import "../css/hero.css";
import "../css/BlobSVG.css";

const HeroSection = () => {
  const { language } = useContext(LanguageContext);

  const handleScroll = (targetId) => {
    const targetElement = document.getElementById(targetId);
    if (targetElement) {
      const elementPosition = targetElement.offsetTop;
      window.scrollTo({
        top: elementPosition,
        behavior: "smooth",
      });
    }
  };

  const translations = useMemo(() => (language === "it" ? it : en), [language]);
  const skills = [
    "React",
    "Next.js",
    "Three.js",
    "JavaScript",
    "TypeScript",
    "GSAP",
    "WordPress",
    "Elementor",
    "Shopify",
    "Liquid",
    "Bootstrap",
    "PHP",
    "Laravel",
    "Git",
    "Hydrogen",
    "Node.js",
    "Prisma",
    "Tailwind",
    "SASS",
    "Framer Motion",
    "SQL",
    "Supabase",
  ];

  return (
    <div className="hero-section container mt-5">
      <div className="row">
        <div className="col-lg-6 text-center text-lg-start mt-3">
          <p className="hero-name">
            <Typewriter
              key={language}
              words={[translations.hero.name]}
              loop={1}
              cursor
              cursorStyle="|"
              typeSpeed={80}
              deleteSpeed={50}
              delaySpeed={1000}
            />
          </p>
          <h1 className="hero-title">{translations.hero.title}</h1>
          <p className="hero-description">
            <Typewriter
              key={language}
              words={skills}
              loop={0}
              cursor
              cursorStyle="|"
              typeSpeed={80}
              deleteSpeed={50}
              delaySpeed={2000}
            />
          </p>
        </div>

        <div className="col-lg-6 d-flex justify-content-center align-items-center mt-3">
          <div className="blob-wrapper">
            <BlobSVG />
          </div>
        </div>
        <div
          className="w-100 text-center mt-4"
          id="scroll-down"
          onClick={() => handleScroll("chiSono")}
        >
          <FontAwesomeIcon icon={faAngleDown} className="bounce-icon-hero" />
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
